import { z } from 'zod';
import { requiredString } from '../../../validation';

export const CareDocumentTreatmentDetailsSchema = z.object({
  treatment: requiredString('Treatment to date is required'),
  plan: requiredString('Ongoing treatment plan is required'),
  expectedEndDate: requiredString('Expected treatment end date is required'),
  other: requiredString('Other medical relevant history is required'),
});

export type CareDocumentTreatmentDetails = z.infer<
  typeof CareDocumentTreatmentDetailsSchema
>;
